import { render, staticRenderFns } from "./cmpLoginTokenTimer.vue?vue&type=template&id=12f37f82&"
import script from "./cmpLoginTokenTimer.vue?vue&type=script&lang=js&"
export * from "./cmpLoginTokenTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports